import {
  collection,
  doc,
} from 'firebase/firestore';

import {
  db,
} from '@/services/firebase.js';

import {
  converters,
} from '../converters/index.js';

import {
  timeline_path,
} from './utils.js';

export const timeline_refs = {
  document: ({
    is_published,
    workspace_id,
    project_id,
    timeline_id,
  }) => {
    const path = timeline_path({
      is_published,
      workspace_id,
      project_id,
      timeline_id,
    });
    return doc(db, path).withConverter(converters.timelines);
  },
  collection: ({
    is_published,
    workspace_id,
    project_id,
  }) => {
    const path = timeline_path({
      is_published,
      workspace_id,
      project_id,
    });
    return collection(db, path).withConverter(converters.timelines);
  },
};
